import React from "react";
import { LanderTemplate } from "../commons/constants/Templates";
import { DomainStatus } from "../commons/Constants";
import SimpleLayout from "./cashparking/SimpleLayout";
import HegLayout from "./parkweb/HegLayout";
import ParkWebLayout from "./parkweb/ParkWebLayout";
import { ModernLayout } from "./modern";
import { useLanderConfig } from "../commons/ConfigContext";
import { useYahooModernExperiment } from "../experimentation/useYahooModernExperiment";
import { useRsocUrl } from "../rsoc/useRsoc";
import { InactiveLander } from "./InactiveLander";
import { Redirect } from "./Redirect";
import TargetedLander from "./TargetedLander";

export default function LanderRouter() {
  const { landerConfig, queryConfig, targeted } = useLanderConfig();
  const { showModernLayout } = useYahooModernExperiment();
  const rsoc = useRsocUrl();

  // 1. Targeted (FOS iframe)
  if (targeted) {
    return <TargetedLander targeted={ targeted } queryConfig={ queryConfig } />;
  }

  // 2. Inactive domain - fires ERROR event
  // Missing status is treated as inactive (API should always include status for valid domains)
  if (landerConfig.domain?.status?.internal !== DomainStatus.ACTIVE) {
    return <InactiveLander />;
  }

  // 3. TurnKey Reseller redirect
  const turnKeyUrl = landerConfig.turnKeyReseller?.redirectUrl?.trim();
  if (turnKeyUrl?.length) {
    return <Redirect to={ turnKeyUrl } replace />;
  }

  // 4. RSOC redirect
  if (rsoc.shouldRedirect && rsoc.url) {
    return <Redirect to={ rsoc.url } />;
  }

  // 5. Template-based layout
  switch (landerConfig.lander.template) {
    case LanderTemplate.PARK_WEB:
      return <ParkWebLayout />;
    case LanderTemplate.PARK_WEB_HEG:
      return <HegLayout />;
    default:
      return showModernLayout ? <ModernLayout /> : <SimpleLayout />;
  }
}
